import styled from 'styled-components';

export const CardTitle = styled.h4`
 color: rgb(227, 6, 19);
`

export const CardDesc = styled.p`
`

export const CardListWrap = styled.section`
  display:flex;
  flex-direction:row;
  flex-wrap: wrap;
`

export const StyledCardMainWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 600px) {
    flex-direction: row;
  }

  @media (min-width: 1200px) {
    flex-direction: column;
  }
`